import { render, staticRenderFns } from "./CommentsInput.vue?vue&type=template&id=52b906b8"
import script from "./CommentsInput.vue?vue&type=script&lang=js"
export * from "./CommentsInput.vue?vue&type=script&lang=js"
import style0 from "./CommentsInput.vue?vue&type=style&index=0&id=52b906b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports